import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

interface Slide {
  comicId: string;
  title: string;
  description: string;
  image: string;
  tag: string;
}

const slides: Slide[] = [
  {
    comicId: 'heilianhua',
    title: '黑莲花攻略手册',
    description: '穿进狗血玄幻小说，凌妙妙被迫攻略那个身世悲惨的腹黑少年慕声。阴郁暴戾的他，唯独对她露出最柔软的一面。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ink%20painting%20style%20illustration%20of%20a%20mysterious%20ancient%20Chinese%20palace%20with%20dark%20lotus%20flowers%20blooming%20in%20a%20moonlit%20pond%2C%20soft%20candlelight%20glowing%20from%20paper%20lanterns%2C%20silhouettes%20of%20two%20figures%20in%20traditional%20hanfu%2C%20atmospheric%20mist%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20dreamy%20romantic%20mood%2C%20rich%20texture&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
    tag: '今日推荐',
  },
  {
    comicId: 'doupocangqiong',
    title: '斗破苍穹',
    description: '天才少年萧炎一夜之间变成废人，绝望之际药老出现，开启逆天之路。三十年河东三十年河西，莫欺少年穷！',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20battle%20scene%20with%20a%20young%20warrior%20surrounded%20by%20raging%20flames%20and%20mystical%20energy%2C%20ancient%20mountain%20landscape%2C%20dramatic%20lighting%20with%20orange%20fire%20against%20dark%20sky%2C%20dynamic%20martial%20arts%20pose%2C%20cinematic%20composition%2C%20warm%20red%20and%20gold%20tones&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
    tag: '经典必读',
  },
  {
    comicId: 'modaozushi',
    title: '魔道祖师',
    description: '夷陵老祖魏无羡死后十三年重生归来，与故人蓝忘机携手揭开埋藏十几年的惊天秘密。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20cultivation%20fantasy%20scene%20with%20a%20man%20in%20flowing%20black%20robes%20playing%20a%20flute%20on%20a%20misty%20mountain%20cliff%2C%20ghostly%20blue%20spirits%20floating%20around%2C%20ancient%20Chinese%20landscape%20painting%20style%2C%20moonlight%20illuminating%20clouds%2C%20atmospheric%20and%20haunting&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
    tag: '人气推荐',
  },
];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden" aria-label="推荐漫画轮播">
      {slides.map((slide, index) => (
        <div
          key={slide.comicId}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
        </div>
      ))}

      <div className="absolute inset-0 z-20 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-lg">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
              {slides[current].tag}
            </span>
            <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 leading-tight">
              {slides[current].title}
            </h1>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-md">
              {slides[current].description}
            </p>
            <Link
              to={`/comic/${slides[current].comicId}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即阅读
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/40 transition-colors cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-white text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/40 transition-colors cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-white text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}